import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import {CustomerEvaluationsComponent } from './customer-evaluations.component';

const routes: Routes = [
	{
		path: 'avaliacoes/:company_name', component: CustomerEvaluationsComponent
	},
	{
		path: 'avaliacoes/:company_name/:questionnaire_type', component: CustomerEvaluationsComponent
	}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class CustomerEvaluationsRoutingModule { }
